module.exports = __webpack_public_path__ + "img/ZM.f5b0c1f7.svg";